import { Link, useLocation } from "react-router-dom";
import PageMeta from "@/components/base/PageMeta";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <PageMeta
        title="页面未找到 - JMComic漫画频道"
        description="你访问的页面不存在，请返回 JMComic 首页继续浏览精选漫画与最新连载。"
        keywords="JMComic,页面未找到,漫画平台"
        path={location.pathname}
      />
      <div className="mx-auto flex w-full max-w-[1240px] flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="font-heading text-[80px] font-extrabold leading-none text-primary-200 md:text-[120px]">
          404
        </span>
        <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950">页面未找到</h1>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的地址可能已经变更或被移除。回到首页，或者从分类里继续找找想看的漫画。
        </p>
        <p className="mt-2 rounded bg-background-100 px-3 py-1 text-[11px] text-foreground-400">
          {location.pathname}
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Link
            to="/"
            className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 hover:bg-primary-600"
          >
            <i className="ri-home-5-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/all"
            className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          >
            浏览全部漫画
          </Link>
          <Link
            to="/search"
            className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          >
            搜索漫画
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}